module.exports = __webpack_public_path__ + "img/fees.weekly.d5a400ca.png";